module.exports = "/static/fonts/Framework7Icons-Regular.0efb066.woff";


//////////////////
// WEBPACK FOOTER
// ./~/framework7-icons/fonts/Framework7Icons-Regular.woff
// module id = 803
// module chunks = 2